/* istanbul ignore file */
import moment from 'moment';
import { SEARCH_DATE_FORMAT } from 'common/constants/constants';
import { PERIODS, PERIODS_TYPES } from './constants';
import get from 'lodash/get';

export const getLastXQuartersPeriods = x => {
  moment().quarter(moment().quarter()).startOf('quarter');

  const quartersPeriods = [];
  for (let i = 1; i <= x; i++) {
    const quarter = moment().subtract(i, 'Q');
    const prevQuarter = moment().subtract(i + 1, 'Q');

    const quarterPeriod = {
      periodKey: quarter.format('[Q]Q_Y'),
      menuName: quarter.format('[Q]Q Y'),
      topReviewerText: `in ${quarter.format('[Q]Q Y')}`,
      after: moment(quarter.year(), 'YYYY')
        .quarter(quarter.quarter())
        .startOf('quarter'),
      before: moment(quarter.year(), 'YYYY')
        .quarter(quarter.quarter())
        .endOf('quarter'),
      prev_after: moment(prevQuarter.year(), 'YYYY')
        .quarter(prevQuarter.quarter())
        .startOf('quarter'),
      prev_before: moment(prevQuarter.year(), 'YYYY')
        .quarter(prevQuarter.quarter())
        .endOf('quarter'),
      type: PERIODS_TYPES.CALENDAR
    };
    quartersPeriods.push(quarterPeriod);
  }

  return quartersPeriods;
};

export const getSelectedPeriodType = selectedPeriod => {
  const { periodKey } = selectedPeriod;
  return get(PERIODS, `[${periodKey}].type`);
};

export const getPeriodDurationText = (startDate, endDate) => {
  const year = moment(endDate).format('YYYY');
  const startPeriod = moment(startDate).format('MMM DD');
  const endPeriod = moment(endDate).format('MMM DD');
  const periodDurationText = `${startPeriod} - ${endPeriod} ${year}`;
  return periodDurationText;
};

export const getPrevDateRange = ({
  dateRange,
  selectedPeriodKey,
  prevIteration
}) => {
  const daysInDateRange = moment(dateRange.to).diff(
    moment(dateRange.from),
    'days'
  );

  const prevBefore = moment(dateRange.from).subtract(1, 'days');
  const prevAfter = moment(prevBefore).subtract(daysInDateRange, 'days');

  if (selectedPeriodKey === PERIODS.ITERATIONS.periodKey && !!prevIteration) {
    return {
      from: prevIteration?.start_date,
      to: prevIteration?.end_date
    };
  } else if (
    selectedPeriodKey === PERIODS.CUSTOM.periodKey ||
    (selectedPeriodKey === PERIODS.ITERATIONS.periodKey && !prevIteration)
  ) {
    return {
      from: moment(prevAfter).format(SEARCH_DATE_FORMAT),
      to: moment(prevBefore).format(SEARCH_DATE_FORMAT)
    };
  } else {
    if (!PERIODS[selectedPeriodKey]) {
      // Datadog log to track no selectedPeriodKey
      window.DD_LOGS &&
        window.DD_LOGS.logger.error('PERIODS[selectedPeriodKey] is undefined', {
          selectedPeriodKey
        });

      return {
        from: moment(prevAfter).format(SEARCH_DATE_FORMAT),
        to: moment(prevBefore).format(SEARCH_DATE_FORMAT)
      };
    }

    return {
      from: moment(PERIODS[selectedPeriodKey].prev_after).format(
        SEARCH_DATE_FORMAT
      ),
      to: moment(PERIODS[selectedPeriodKey].prev_before).format(
        SEARCH_DATE_FORMAT
      )
    };
  }
};
